export default "__VITE_ASSET__DUXtB10f__"